import React, { useState, useContext } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { EditExerciseDialog } from "../../components/exercise/EditExerciseDialog";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";
import axios from "axios";
import { useSnackbar } from "notistack";

export const ExerciseItem = ({
  id,
  name,
  bmname,
  hold,
  repeat,
  timesperday,
  onExerciseUpdate,
}) => {
  const { token } = useAuthContext();
  const img = require(`../../assets/exercise/${bmname}.png`);
  const { darkMode } = useContext(ThemeContext);
  const [openEditDialog, setOpenEditDialog] = useState(false); // New state for confirmation dialog
  const [exerciseToEdit, setExerciseToEdit] = useState(null); // New state for the user to be deleted
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/exercise/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setExerciseToEdit(response.data);
    setOpenEditDialog(true);
  };

  const handleCancelEdit = () => {
    setOpenEditDialog(false);
  };

  const handleEditExercise = async (data) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/exercise/${data.id}`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      onExerciseUpdate(response.data); // Update the parent state
      enqueueSnackbar("Successfully Changed!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to update exercise!", { variant: "error" });
    }
  };

  const handleDeleteExercise = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/exercise/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      onExerciseUpdate({ id, deleted: true }); // Notify parent about the deletion
      setOpenEditDialog(false);
      enqueueSnackbar("Successfully Deleted!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to delete exercise!", { variant: "error" });
    }
  };

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          width: "475px",
          height: "120px",
          padding: 1,
          borderRadius: "5px",
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: darkMode
            ? getColors.thumbnailBorderDark
            : getColors.thumbnailBorderLight,
          background: darkMode
            ? getColors.thumbnnailBgDark
            : getColors.thumbnnailBgLight,
          cursor: "pointer",
          "&:hover": {
            borderColor: darkMode
              ? getColors.thumbnailTextDark
              : getColors.thumbnailTextLight,
          },
        }}
        onClick={handleClick} // Move the onClick handler here
      >
        <Box>
          <Box display={"flex"} alignItems={"center"}>
            <img
              src={img}
              alt="img"
              style={{ width: "100px", height: "75px" }}
            />
            <Typography
              sx={{
                fontSize: "22px",
                fontWeight: 500,
                color: darkMode
                  ? getColors.drawerTextDark
                  : getColors.thumbnailTextLight,
                ml: "20px",
              }}
            >
              {name}
            </Typography>
          </Box>
          <Box display={"flex"}>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: darkMode
                  ? getColors.drawerTextDark
                  : getColors.thumbnailTextLight,
                ml: "15px",
              }}
            >
              {`Hold=${hold}`}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: darkMode
                  ? getColors.drawerTextDark
                  : getColors.thumbnailTextLight,
                mx: "20px",
              }}
            >
              {`Repeat=${repeat}`}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: darkMode
                  ? getColors.drawerTextDark
                  : getColors.thumbnailTextLight,
              }}
            >
              {`PerDay=${timesperday}`}
            </Typography>
          </Box>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"flex-end"}
          width="max-content"
          sx={{
            borderRadius: "50%",
            padding: "20px",
            color: "#007FFF",
            bgcolor: "#E9F3FF",
            alignItems: "center",
            "&:hover": {
              color: "blue",
            },
            ml: 4,
            mr: 2,
          }}
        >
          <BorderColorOutlinedIcon />
        </Box>
      </Box>
      <EditExerciseDialog
        open={openEditDialog}
        onClose={handleCancelEdit}
        exerciseData={exerciseToEdit}
        onSave={handleEditExercise}
        onRemove={handleDeleteExercise}
      />
    </>
  );
};
